export const detailPageStyle = (isMobile) => ({
  padding: isMobile ? 10 : 16,
  display: 'grid',
  gap: isMobile ? 10 : 16,
  minWidth: 0,
});

export const detailHeaderStyle = (isMobile) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: isMobile ? 'flex-start' : 'center',
  gap: 10,
  flexWrap: 'wrap',
});

export const detailTitleRowStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  minWidth: 0,
  flexWrap: 'wrap',
};

export const detailBackButtonStyle = {
  padding: '4px 10px',
  background: 'transparent',
  border: '1px solid var(--border)',
  borderRadius: 4,
  cursor: 'pointer',
  color: 'var(--text-muted)',
  fontSize: 12,
};

export const detailCodeStyle = {
  fontSize: 18,
  fontWeight: 800,
  color: 'var(--text)',
};

export const detailCustomerStyle = {
  color: 'var(--text-muted)',
  fontSize: 14,
};

export const detailStatusStyle = {
  fontSize: 11,
  padding: '3px 10px',
  borderRadius: 999,
  background: 'var(--bg)',
  color: 'var(--text-muted)',
};

export const detailMainGridStyle = (isMobile) => ({
  display: 'grid',
  gridTemplateColumns: isMobile ? '1fr' : 'minmax(280px, 320px) 1fr',
  gap: isMobile ? 10 : 16,
  minWidth: 0,
});

export const tabShellStyle = {
  background: 'var(--bg-card)',
  border: '1px solid var(--border)',
  borderRadius: 8,
  overflow: 'hidden',
  minWidth: 0,
};

export const tabHeaderStyle = (isMobile) => ({
  display: 'flex',
  borderBottom: '1px solid var(--border)',
  overflowX: isMobile ? 'auto' : 'visible',
});

export const tabButtonStyle = (active, isMobile) => ({
  flex: isMobile ? '0 0 auto' : 1,
  minWidth: isMobile ? 82 : 0,
  padding: isMobile ? '9px 12px' : '10px 12px',
  background: active ? 'var(--accent-700, #7c3aed)' : 'transparent',
  color: active ? '#fff' : 'var(--text-muted)',
  border: 'none',
  cursor: 'pointer',
  fontSize: 13,
  fontWeight: 700,
  borderRight: '1px solid var(--border)',
  whiteSpace: 'nowrap',
});

export const tabBodyStyle = (isMobile) => ({
  padding: isMobile ? 10 : 12,
  minWidth: 0,
});

export const mobileTabWrap = {
  display: 'grid',
  gap: 10,
  minWidth: 0,
};

export const mobileTopActionRow = {
  display: 'flex',
  justifyContent: 'flex-end',
};

export const mobileAddButton = {
  padding: '7px 10px',
  background: 'var(--accent-700, #7c3aed)',
  color: '#fff',
  border: 'none',
  borderRadius: 6,
  cursor: 'pointer',
  fontSize: 12,
  fontWeight: 800,
};

export const mobileCardList = {
  display: 'grid',
  gap: 10,
  minWidth: 0,
};

export const mobileCard = {
  display: 'grid',
  gap: 9,
  padding: 11,
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--bg)',
  minWidth: 0,
};

export const mobileCardHeader = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: 10,
  minWidth: 0,
};

export const mobileCardTitle = {
  display: 'grid',
  gap: 2,
  minWidth: 0,
};

export const mobileTitleText = {
  fontSize: 13,
  fontWeight: 800,
  color: 'var(--text)',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const mobileSubText = {
  fontSize: 11,
  color: 'var(--text-muted)',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const mobileAmount = (danger = false) => ({
  flex: '0 0 auto',
  fontSize: 14,
  fontWeight: 900,
  color: danger ? '#dc2626' : 'var(--text)',
  whiteSpace: 'nowrap',
});

export const mobileInfoGrid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: '7px 10px',
  minWidth: 0,
};

export const mobileInfoItem = {
  display: 'grid',
  gap: 2,
  minWidth: 0,
};

export const mobileInfoLabel = {
  fontSize: 10,
  color: 'var(--text-muted)',
  whiteSpace: 'nowrap',
};

export const mobileInfoValue = {
  fontSize: 12,
  color: 'var(--text)',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const mobileActionRow = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 6,
  borderTop: '1px solid var(--border)',
  paddingTop: 8,
};

export const mobileEditButton = {
  padding: '5px 9px',
  background: 'transparent',
  color: 'var(--accent-300, #a78bfa)',
  border: '1px solid var(--accent-700, #7c3aed)',
  borderRadius: 5,
  cursor: 'pointer',
  fontSize: 11,
  fontWeight: 700,
};

export const mobileDeleteButton = {
  padding: '5px 9px',
  background: 'transparent',
  color: '#dc2626',
  border: '1px solid #dc2626',
  borderRadius: 5,
  cursor: 'pointer',
  fontSize: 11,
  fontWeight: 700,
};

export const mobileEmpty = {
  padding: 16,
  color: 'var(--text-muted)',
  textAlign: 'center',
  fontSize: 12,
  border: '1px dashed var(--border)',
  borderRadius: 8,
};
